import xior from 'xior';
import Router from 'next/router';

const xiorInstance = xior.create({
  baseURL:
    `${process.env.NEXT_PUBLIC_API_BASE_URL}` ||
    'https://dev-api.imei.best/api',
});

xiorInstance.interceptors.request.use((config) => {
  if (!config.headers['Accept-Language'] && Router.locale) {
    config.headers['Accept-Language'] = Router.locale;
  }

  return config;
});

xiorInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default xiorInstance;
